import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate from react-router-dom
import { 
  FaNodeJs, 
  FaReact, 
  FaDatabase, 
  FaFigma, 
  FaJsSquare,
  FaPython 
} from "react-icons/fa";
import { 
  SiAntdesign, 
  SiMui,
  SiTypescript,
  SiExpress,
  SiFastapi
} from "react-icons/si";
import "./WebList.css"; // Add your custom CSS for styling and animations
import LogoLoop from "../components/LogoLoop/LogoLoop";

const WebList = () => {
  const navigate = useNavigate(); // Get navigate function from useNavigate

  const services = [
    { 
      name: "Auto Backup", 
      imgSrc: "/images/DALL·E 2024-10-21 09.58.25 - A clean and modern image of a desktop computer with an auto-backup application on the screen. The application interface should show a progress bar ind.webp", 
      description: "A robust desktop application designed to automate business processes efficiently, tailored to meet the specific needs of your organization.",
      path: "/autoBackupSoftware" // Add a path for Auto Desktop Application
    },
    { 
      name: "E-Warehouse Data Storage", 
      imgSrc: "/images/Screenshot (108).png", 
      description: "A secure cloud-based data storage solution, allowing businesses to manage and store data seamlessly while ensuring maximum security and availability.",
      path: "/e_data" // Path for E-warehouse
    },
    { 
      name: "Purchase Request Modules ", 
      imgSrc: "/images/service/Screenshot (121).png", 
      description: "A comprehensive module to streamline the purchase request process, improving efficiency and reducing manual workload.",
      path: "/pr" // Path for Purchase Request Module Application
    },
    { 
      name: "Logistics modules ", 
      imgSrc: "/images/service/image.png", 
      description: "A transport management system that simplifies logistics and fleet tracking, offering real-time updates and efficient management tools.",
      path: "/tr" // Path for Transport Web Application
    },
  ];

  const handleServiceClick = (service) => {
    navigate(service.path); // Navigate to the service path
  };

  return (
    <div className="web-page">
      <br/>
      <br/>

   
      <h1>Our Services</h1>
      <div className="web-container">
        {services.map((service, index) => (
          <div key={index} className="web-card" onClick={() => handleServiceClick(service)}>
            <img src={service.imgSrc} alt={service.name} className="service-img" />
            <h2>{service.name}</h2>
            <p>{service.description}</p>
          </div>
        ))}
      </div>

      {/* ── Technology Section ── */}
      <section className="tech-showcase-section">
        <div className="tech-badge">Enterprise Ready</div>
        <h2>Technology We Leverage</h2>
        <p className="tech-intro">
          We use a battle-tested tech stack to build scalable, secure, and high-performance applications.
        </p>
        
        <div className="tech-loop-container">
          <LogoLoop
            logos={[
              { node: <FaReact style={{ color: '#61DAFB' }} />, title: "React.js" },
              { node: <FaJsSquare style={{ color: '#323330', backgroundColor: '#F7DF1E', borderRadius: '4px' }} />, title: "JavaScript" },
              { node: <SiTypescript style={{ color: '#3178C6' }} />, title: "TypeScript" },
              { node: <SiAntdesign style={{ color: '#0170FE' }} />, title: "Ant Design" },
              { node: <SiMui style={{ color: '#007FFF' }} />, title: "Material UI" },
              { node: <FaNodeJs style={{ color: '#339933' }} />, title: "Node.js" },
              { node: <SiExpress style={{ color: '#000000' }} />, title: "Express.js" },
              { node: <FaPython style={{ color: '#3776AB' }} />, title: "Python" },
              { node: <SiFastapi style={{ color: '#05998B' }} />, title: "FastAPI" },
              { node: <FaDatabase style={{ color: '#4479A1' }} />, title: "SQL Database" },
              { node: <FaFigma style={{ color: '#F24E1E' }} />, title: "Figma" },
            ]}
            speed={60}
            gap={80}
            logoHeight={50}
            direction="left"
            fadeOut={false}
            pauseOnHover={true}
            scaleOnHover={true}
          />
        </div>
      </section>
    </div>
  );
};

export default WebList;
